import { cn } from "@/lib/utils";

function CipherIcon({ className }: { className?: string }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect x="2" y="2" width="24" height="24" rx="6" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="14" cy="14" r="5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="14" cy="14" r="1.5" fill="currentColor" />
      <line x1="14" y1="2" x2="14" y2="9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="14" y1="19" x2="14" y2="26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="2" y1="14" x2="9" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="19" y1="14" x2="26" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function BrandMark({ className = "h-7 w-7" }: { className?: string }) {
  return <CipherIcon className={cn("text-primary", className)} />;
}

export function BrandText({ className = "" }: { className?: string }) {
  return (
    <span className={cn("font-display font-bold tracking-[0.08em] uppercase text-sm", className)}>
      Hideaway
    </span>
  );
}

export function BrandFull({
  className = "",
  iconClass = "h-6 w-6",
  textClass = "text-sm",
}: {
  className?: string;
  iconClass?: string;
  textClass?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <BrandMark className={iconClass} />
      <BrandText className={textClass} />
    </span>
  );
}
